import React from 'react';
import HeroSplit from '../components/sections/HeroSplit';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Cta from '../components/sections/Cta';

class Home extends React.Component {
  render() {
    return (
      <React.Fragment>
        <HeroSplit />
        <FeaturesTiles topDivider />
        <FeaturesSplit topDivider invertMobile />
        <Cta topDivider split className="reveal-from-top" />
      </React.Fragment>
    );
  }
}

export default Home;
